import { useMemo } from 'react'

export const useConcat = <R>(...arrays: any[]) => {
	return useMemo<R>(() => arrays.reduce((a, b) => a.concat(b), []), arrays)
}
